export default __webpack_public_path__ + "static/cardstwo-eaec0e450b08f17b89a0bcb7e4ecd1e9.png";